<template>
  <v-container fluid id="fcreate">
    <breadcrumbs/>
    <v-row>
      <v-col>
        <h1 class="mb-1">
          {{ getTitle }}
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-form v-model="valid" ref="form">
        <v-container fluid>
          <v-row>
            <!-- Заголовок -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.name"
                label="Заголовок"
                outlined
                required
                :rules="rules.required"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Подзаголовок -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.subTitle"
                label="Подзаголовок"
                outlined
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Слаг -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.slug"
                label="Слаг"
                outlined
                required
                :rules="rules.slug"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Описание -->
            <v-col
              cols="12"
              md="7"
            >
              <v-textarea
                v-model="data.description"
                label="Описание"
                outlined
                required
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Иконка -->
            <v-col
              cols="12"
              md="7"
            >
              <div
                class="text-body mb-2"
                v-text="'Иконка'"
              />
              <upload-image
                v-model="data.ico"
                color="primary"
                label="Загрузить иконку"
              >
                Загрузить иконку
              </upload-image>
            </v-col>
            <!-- Тип -->
            <v-col
              cols="12"
              md="7"
            >
              <v-select
                v-model="data.types"
                :items="['desktop', 'mobile', 'crm']"
                label="Тип"
                outlined
                multiple
                :rules="rules.selectMultipleRequired"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Цель -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.target"
                label="Цель"
                outlined
                required
                :rules="rules.selectMultipleRequired"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Сортировка -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.sortOrder"
                label="Индекс сортировки"
                outlined
                required
                :rules="[...rules.required, ...rules.number]"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Категория -->
            <v-col
              cols="12"
              md="7"
            >
              <v-select
                v-model="data.categoryId"
                :items="computedCategories"
                item-text="name"
                item-value="id"
                outlined
                label="Категория"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Блюда в подборке -->
            <v-col
              cols="12"
              md="7"
            >
              <v-autocomplete
                v-model="menuItems.model"
                :items="getMenuItemsList"
                item-text="name"
                item-value="id"
                label="Блюда в подборке"
                outlined
                chips
                deletable-chips
                multiple
                :rules="rules.selectMultipleRequired"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Submit -->
            <v-col cols="12" md="7">
              <v-row>
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    block
                    large
                    color="primary"
                    :loading="loadingForm"
                    :disabled="loadingForm"
                    @click.prevent="save"
                  >
                    Сохранить
                  </v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    block
                    large
                    color="success"
                    :loading="loadingForm"
                    :disabled="loadingForm"
                    @click.prevent="save(false)"
                  >
                    Применить
                  </v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    block
                    large
                    color="error"
                    :loading="loadingForm"
                    :disabled="loadingForm"
                    @click.prevent="$router.push('/collections')"
                  >
                    Отменить
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'
  import snackbarMessage from '@/mixins/snackbar-message'

  export default {
    mixins: [rules, snackbarMessage],
    data () {
      return {
        data: {},
        menuItems: {
          model: [],
          data: [],
        },
        valid: false,
        edit: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarSuccess: false,
      }
    },
    watch: {
      'menuItems.model' (newValue) {
        this.menuItems.data = newValue.map(v => {
          return {
            id: v,
          }
        })
      },
    },
    computed: {
      ...mapGetters({
        getCollectionsSingle: 'collections/getCollectionsSingle',
        getCategoriesList: 'categories/getCategoriesList',
        getMenuItemsList: 'menuItems/getMenuItemsList',
      }),
      computedCategories: {
        get () {
          const emptyCategory = {
            id: null,
            name: '–',
          }
          return [emptyCategory, ...this.getCategoriesList]
        },
      },
      getId () { return this.$route.params.id || null },
      getName () { return (this.getCollectionsSingle) ? this.getCollectionsSingle.name : '' },
      getTitle () { return `Коллекция: "${ this.getName }"` },
    },
    methods: {
      editCollections () {
        this.edit = true
        this.menuItems.model = this.getCollectionsSingle ? this.getCollectionsSingle.menuItems.map(v => v.id) : []
        this.data = {
          name: (this.getCollectionsSingle) ? this.getCollectionsSingle.name : '',
          subTitle: (this.getCollectionsSingle) ? this.getCollectionsSingle.subTitle : '',
          slug: (this.getCollectionsSingle) ? this.getCollectionsSingle.slug : '',
          ico: (this.getCollectionsSingle) ? this.getCollectionsSingle.ico : '',
          types: (this.getCollectionsSingle) ? this.getCollectionsSingle.types : '',
          target: (this.getCollectionsSingle) ? this.getCollectionsSingle.target : '',
          description: (this.getCollectionsSingle) ? this.getCollectionsSingle.description : '',
          menuItems: (this.getCollectionsSingle) ? this.getCollectionsSingle.menuItems : [],
          categoryId: (this.getCollectionsSingle.category) ? this.getCollectionsSingle.category.id : '',
          sortOrder: (this.getCollectionsSingle) ? this.getCollectionsSingle.sortOrder : 1,
          status: true,
        }
        this.selectVModel = this.getFilials ? this.getFilials.map(v => v.name) : []
      },
      async save (redirect = true) {
        this.loadingForm = true

        const validate = await this.$refs.form.validate()

        if (validate) {
          try {
            this.data.filials = this.selectDataArray
            this.data.menuItems = this.menuItems.data
            const res = await this.$store.dispatch('collections/editCollections', { data: this.data, id: this.getId })
            if (res.status && res.status === 200) {
              this.showSuccessMessage('Изменения сохранены')
              if (redirect) {
                await this.$router.push('/collections')
              }
            } else {
              this.snackbarSuccess = true
              setTimeout(() => {
                this.snackbarSuccess = false
              }, 3000)
            }
          } catch (e) { console.log(e) }
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
        this.loadingForm = false
      },
    },
    async created () {
      if (this.getId) {
        try {
          this.loading = true
          await this.$store.dispatch('collections/fetchSingleCollections', this.getId)

          await this.$store.dispatch('categories/fetchCategoriesList', {
            limit: 10000,
            offset: 0,
            page: 1,
          })

          await this.$store.dispatch('menuItems/fetchMenuItemsList', {
            limit: 10000,
            offset: 0,
            page: 1,
          })

          this.editCollections()
        } finally {
          this.loading = false
        }
      } else {
        await this.$router.push('/collections')
      }
    },
    beforeDestroy () {
      this.$store.commit('collections/clearCollectionsSingle')
    },
  }
</script>
